import { useMemo } from "react";

import { useLobApi } from "../../../hooks/useLobApi";
import type { LobMetrics } from "../../../types";
import { requestParams } from "app/services/fetchService";
import { useCurrentStateAndParams } from "@uirouter/react";
import DurationService, { BasicDurations } from "app/services/DurationService";

export interface SiteVisitsOvertime {
    SiteVisits: { [date: string]: number };
    TotalLobsVisits: {
        [lobName: string]: LobMetrics;
    };
    LobsMonthlyBreakDown: {
        [date: string]: {
            [lobName: string]: { Visits: number };
        };
    };
}

interface VisitsOvertimeResponse {
    Data: Record<string, SiteVisitsOvertime>;
}

const ENDPOINT = "api/websiteContent/lob/Graph";
const EXCEL_ENDPOINT = "api/websiteContent/lob/Excel";

export const useVisitsOvertimeData = () => {
    const { data: response, isLoading } = useLobApi<VisitsOvertimeResponse>(ENDPOINT, "lob-graph-chart");
    const data = useMemo(() => response?.Data ?? null, [response]);

    const {
        params: { duration, key, comparedDuration, country, webSource },
    } = useCurrentStateAndParams();

    const { from, to } = DurationService.getDurationData(duration, comparedDuration).forAPI;

    const queryParams = {
        country,
        webSource,
        keys: key,
        from,
        to,
        includeSubDomains: true,
    };

    const paramsAsString = requestParams(queryParams);
    const excelUrl = `${EXCEL_ENDPOINT}?${paramsAsString}`;
    return { data, isLoading, excelUrl };
};
